<template>
  <div class="account-page login-template-page" :class="`login-period-${loginPeriod}`"
    :style="loginBackgroundStyle">
    <div class="login-language-switcher">
      <vue-feather type="globe" size="17"></vue-feather>
      <label for="login-language" class="visually-hidden">{{ $t("language.label") }}</label>
      <select id="login-language" :value="currentLocale" @change="changeLanguage($event.target.value)">
        <option v-for="language in languages" :key="language.code" :value="language.code">
          {{ language.label }}
        </option>
      </select>
      <vue-feather type="chevron-down" size="15"></vue-feather>
    </div>
    <div class="account-content login-template-content">
      <div class="login-template-shell">
        <main class="login-form-panel">
          <div class="login-content">
          <VForm
            @submit="onSubmit"
            :validation-schema="schema"
            v-slot="{ errors }"
          >
            <div class="login-userset">
              <div class="login-logo logo-normal">
                <img :src="loginLogoUrl" :alt="companyName" @error="useDefaultBranding" />
              </div>
              <router-link to="/dashboard" class="login-logo logo-white">
                <img src="@/assets/img/logo-white.png" alt="" />
              </router-link>
              <div class="login-userheading">
                <h3>{{ $t('loginUi.welcome') }}</h3>
                <h4>{{ $t("login.intro") }}</h4>
              </div>
              <div
                class="emailshow text-danger align-center font-14"
                id="email"
              ></div>
              <div class="form-login mb-3">
                <label class="form-label">{{ $t("login.email") }}</label>
                <div class="form-addons">
                  <VField
                    name="email"
                    type="email"
                    autocomplete="email"
                    :placeholder="$t('loginUi.emailPlaceholder')"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email }"
                  />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <span class="field-icon" aria-hidden="true">
                    <vue-feather type="mail" size="17"></vue-feather>
                  </span>
                </div>
              </div>
              <div class="form-login mb-3">
                <label class="form-label">{{ $t("login.password") }}</label>
                <div class="pass-group">
                  <VField
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="current-password"
                    :placeholder="$t('loginUi.passwordPlaceholder')"
                    class="form-control pass-input mt-2"
                    :class="{ 'is-invalid': errors.password }"
                  />
                  <span @click="toggleShow" class="toggle-password">
                    <i
                      :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <div class="invalid-feedback">{{ errors.password }}</div>
                  <div class="emailshow text-danger" id="password"></div>
                </div>
              </div>
              <div class="login-forgot-row">
                <router-link to="/forgot-password">{{ $t('passwordRecovery.forgotLink') }}</router-link>
              </div>
              <div class="form-login">
                <button type="submit" class="btn btn-login">
                  {{ $t("login.submit") }}
                  <vue-feather type="arrow-right" class="login-submit-arrow"></vue-feather>
                </button>
              </div>
              <!-- <div class="signinform mt-3">
                <h6>
                  <router-link to="/signup" class="hover-a">Demander un accès (préinscription)</router-link>
                </h6>
              </div> -->
            </div>
          </VForm>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { router } from "@/router";
import { Form as VForm, Field as VField } from "vee-validate";
import * as Yup from "yup";
import { login, getCurrentUser } from "@/services/authService";
import { getPublicBranding } from "@/services/companyService";
import { toast } from "vue3-toastify";
import { i18n, setAppLocale } from "@/i18n";
export default {
  components: {
    VForm,
    VField,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
      companyName: "Business Manager",
      brandingCompanyName: "",
      loginLogoUrl: require("@/assets/img/logo.png"),
      defaultLogoUrl: require("@/assets/img/logo.png"),
      defaultFaviconUrl: require("@/assets/img/nedam_icon2.svg"),
      languages: [
        { code: "fr", label: "Français" },
        { code: "en", label: "English" },
        { code: "ar", label: "العربية" },
      ],
      loginPeriod: "day",
      backgroundTimer: null,
      loginBackgrounds: {
        morning: require("@/assets/img/login-backgrounds/morning.jpg"),
        day: require("@/assets/img/login-backgrounds/day.jpg"),
        sunset: require("@/assets/img/login-backgrounds/sunset.jpg"),
        night: require("@/assets/img/login-backgrounds/night.jpg"),
      },
    };
  },
  computed: {
    currentLocale() {
      return i18n.global.locale.value;
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    loginBackgroundStyle() {
      const image = this.loginBackgrounds[this.loginPeriod] || this.loginBackgrounds.day;
      return { backgroundImage: `linear-gradient(rgba(7, 25, 42, .30), rgba(7, 25, 42, .42)), url(${image})` };
    },
  },
  mounted() {
    this.loadPublicBranding();
    this.updateLoginPeriod();
    this.backgroundTimer = window.setInterval(this.updateLoginPeriod, 60 * 1000);
  },
  beforeUnmount() {
    if (this.backgroundTimer) window.clearInterval(this.backgroundTimer);
  },
  methods: {
    updateLoginPeriod() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 10) this.loginPeriod = "morning";
      else if (hour >= 10 && hour < 17) this.loginPeriod = "day";
      else if (hour >= 17 && hour < 20) this.loginPeriod = "sunset";
      else this.loginPeriod = "night";
    },
    changeLanguage(locale) {
      setAppLocale(locale);
      this.updateDocumentTitle();
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    normalizeStorageUrl(path) {
      if (!path) return null;
      if (/^(https?:\/\/|data:image\/)/i.test(path)) return path;
      const base = (process.env.VUE_APP_URL || window.location.origin).replace(/\/$/, "");
      const cleanPath = path.replace(/^\/?storage\//, "");
      return `${base}/storage/${cleanPath}`;
    },
    setFavicon(href) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = href || this.defaultFaviconUrl;
    },
    updateDocumentTitle() {
      const localizedName = i18n.global.t("app.name");
      document.title = this.brandingCompanyName
        ? `${localizedName} | ${this.brandingCompanyName}`
        : localizedName;
    },
    useDefaultBranding() {
      this.loginLogoUrl = this.defaultLogoUrl;
      this.setFavicon(this.defaultFaviconUrl);
    },
    async loadPublicBranding() {
      try {
        const response = await getPublicBranding();
        const branding = response?.data || {};
        const logo = this.normalizeStorageUrl(branding.logo);
        const favicon = this.normalizeStorageUrl(branding.logo_small) || logo;
        this.brandingCompanyName = branding.name || "";
        this.companyName = branding.name || i18n.global.t("app.name");
        this.loginLogoUrl = logo || this.defaultLogoUrl;
        this.setFavicon(favicon || this.defaultFaviconUrl);
        this.updateDocumentTitle();
      } catch (_) {
        this.useDefaultBranding();
      }
    },
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string()
        .required(() => i18n.global.t("login.emailRequired"))
        .email(() => i18n.global.t("login.emailInvalid")),
      password: Yup.string()
        .min(6, () => i18n.global.t("login.passwordMin"))
        .required(() => i18n.global.t("login.passwordRequired")),
    });
    const onSubmit = async (values) => {
      document.getElementById("email").innerHTML = "";
      document.getElementById("password").innerHTML = "";
      try {
        const response = await login({
          email: values.email,
          password: values.password,
          password_confirmation: values.password,
        });
        const payload = getCurrentUser();
        const roleFromResponse = response?.user?.role?.role;
        const role = roleFromResponse || payload?.role;
        const targetRoute =
          role === "Dev" ? "/support/pending-societes" : "/dashboard";
        router.push(targetRoute);
      } catch (error) {
        document.getElementById("email").innerHTML =
          i18n.global.t("login.invalidCredentials");
        const message =
          error?.response?.data?.message || i18n.global.t("login.genericError");
        toast.error(message);
      }
    };
    return {
      schema,
      onSubmit,
      checked: ref(false),
    };
  },
};
</script>
<style scoped>
.login-language-switcher {
  align-items: center;
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  backdrop-filter: blur(18px) saturate(140%);
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  color: #142d4b;
  display: flex;
  gap: 8px;
  inset-inline-end: 24px;
  padding: 5px 10px;
  position: absolute;
  top: 24px;
  z-index: 3;
}

.login-language-switcher select {
  appearance: none;
  background: transparent;
  border: 0;
  color: #142d4b;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  min-width: 72px;
  outline: 0;
  padding: 6px 18px 6px 2px;
}

:global(html[dir="rtl"]) .login-language-switcher select {
  /* padding: 6px 2px 6px 18px; */
}

@media (max-width: 575px) {
  .login-language-switcher {
    inset-inline-end: 14px;
    top: 14px;
  }
}

/* Typography Hierarchy */
.brand-tagline {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
  text-align: center;
  margin: 12px 0 24px;
  line-height: 1.4;
}

.login-userheading h4 {
  font-size: 15px;
  font-weight: 400;
  color: #475569;
  line-height: 1.5;
  margin-bottom: 24px;
}

.form-login label {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 6px;
}

.form-login input {
  font-size: 14px;
  color: #1e293b;
}

.btn-login {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.signinform h6 {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  text-align: center;
}

.signinform a {
  font-size: 13px;
  font-weight: 500;
  color: #142d4b;
  text-decoration: none;
  transition: color 0.2s;
}

.signinform a:hover {
  color: #2563eb;
  text-decoration: underline;
}

.invalid-feedback,
.emailshow {
  font-size: 12px;
}

/* Layout */
.login-modern {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #142d4b 0%, #fe9e4224 100%);
  padding: 32px 16px;
  position: relative;
  overflow: hidden;
}

.login-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M20 10h20v20H20zM60 10h20v20H60zM20 50h20v20H20zM60 50h20v20H60z'/%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
}

.login-modern::after {
  content: '';
  position: absolute;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255,159,67,0.15) 0%, transparent 70%);
  top: -200px;
  right: -200px;
  border-radius: 50%;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-30px, 30px) scale(1.1);
  }
}

.login-modern .account-content {
  width: 100%;
  position: relative;
  z-index: 1;
}

.login-modern .login-wrapper {
  width: 100%;
  height: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-wrapper.login-centered {
  background: transparent;
}

.login-wrapper.login-centered .login-content {
  width: 100%;
  max-width: 500px;
  height: auto;
  padding: 40px 48px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.login-wrapper.login-centered .login-userset {
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
}

.login-wrapper.login-centered .form-login input {
  height: 44px;
  border-radius: 10px;
  padding-inline: 14px 48px;
}

.login-wrapper.login-centered .field-icon {
  align-items: center;
  color: #7b8ca3;
  display: flex;
  height: 32px;
  inset-inline-end: 14px;
  justify-content: center;
  left: auto;
  pointer-events: none;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
}

.login-wrapper.login-centered .toggle-password {
  align-items: center;
  background: transparent;
  display: flex;
  height: 32px;
  inset-inline-end: 10px;
  justify-content: center;
  left: auto;
  position: absolute;
  right: auto;
  top: 50%;
  transform: translateY(-50%);
  transition: color 0.2s ease, background-color 0.2s ease;
  width: 32px;
}

.login-wrapper.login-centered .toggle-password:hover {
  background: rgba(254, 159, 67, 0.1);
}

:global(html[dir="rtl"]) .login-wrapper.login-centered .form-login input {
  direction: rtl;
  text-align: right;
}

:global(html[dir="rtl"]) .login-wrapper.login-centered input[name="email"] {
  direction: ltr;
  /* padding-left: 50px;
  padding-right: 14px; */
  text-align: right;
}

:global(html[dir="rtl"]) .login-wrapper.login-centered .form-addons .field-icon {
  left: 10px !important;
  right: auto !important;
}

.login-wrapper.login-centered input[name="password"] {
  direction: ltr;
  text-align: left;
}

:global(html[dir="rtl"]) .login-wrapper.login-centered input[name="password"] {
  direction: rtl;
  /* padding-left: 50px;
  padding-right: 14px; */
  text-align: right;
}

:global(html[dir="rtl"]) .login-wrapper.login-centered .pass-group .toggle-password {
  left: 10px !important;
  right: auto !important;
}

.login-wrapper.login-centered .form-login .btn-login {
  border-radius: 10px;
  height: 46px;
  margin-top: 10px;
}

.login-wrapper.login-centered .login-logo img {
  max-height: 52px;
  margin-bottom: 4px;
}

.login-wrapper.login-centered .logo-white {
  display: none;
}

/* Responsive */
@media (max-width: 575px) {
  .login-modern {
    padding: 24px 12px;
  }

  .login-wrapper.login-centered .login-content {
    padding: 32px 24px;
  }

  .login-wrapper.login-centered .login-userset {
    max-width: 100%;
  }

  .login-modern::after {
    width: 400px;
    height: 400px;
    top: -150px;
    right: -150px;
  }

  .brand-tagline {
    font-size: 11px;
    margin: 10px 0 20px;
  }

  .login-userheading h4 {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .form-login label {
    font-size: 12px;
  }

  .form-login input {
    font-size: 13px;
    height: 42px;
  }

  .btn-login {
    font-size: 13px;
    height: 44px;
  }

  .signinform h6,
  .signinform a {
    font-size: 12px;
  }

}

.login-template-page {
  align-items: center;
  background:
    radial-gradient(circle at 38% 38%, rgba(255, 166, 82, .58), transparent 18%),
    radial-gradient(circle at 62% 66%, rgba(104, 203, 235, .62), transparent 22%),
    radial-gradient(circle at 18% 18%, rgba(255, 172, 92, .25), transparent 28%),
    radial-gradient(circle at 82% 78%, rgba(116, 190, 230, .32), transparent 32%),
    linear-gradient(135deg, #102f4b 0%, #356786 52%, #98afbe 100%);
  display: flex;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  overflow: hidden;
  padding: 28px;
  position: relative;
}

.login-template-page::before,
.login-template-page::after {
  display: none;
}

.login-period-night .login-template-shell {
  background: linear-gradient(145deg, rgba(8, 34, 61, .66), rgba(11, 43, 70, .44));
  border-color: rgba(180, 218, 245, .38);
  box-shadow: 0 34px 90px rgba(0, 10, 24, .52), inset 0 1px 0 rgba(255,255,255,.2);
}

.login-period-night .login-userheading h3,
.login-period-night .form-login label {
  color: #f4f9fd !important;
}

.login-period-night .login-userheading h4 {
  color: rgba(225, 239, 249, .82) !important;
}

.login-period-night .form-control {
  background: rgba(242, 248, 253, .9);
  border-color: rgba(220, 237, 249, .72);
  color: #112f4c;
}

.login-period-night .form-control:focus {
  background: #f8fbfe;
}

.login-period-night .login-forgot-row a {
  color: #b9ddf5;
}

.login-period-night .login-forgot-row a:hover {
  color: #ffb66f;
}

.login-period-night .field-icon,
.login-period-night .toggle-password {
  color: #607b94;
}

.login-period-night .login-language-switcher {
  background: rgba(8, 34, 61, .62);
  border-color: rgba(190, 220, 241, .34);
  color: #f2f8fc;
}

.login-period-night .login-language-switcher select {
  color: #f2f8fc;
}

.login-period-night .login-language-switcher option {
  color: #173653;
}

.login-period-sunset .login-template-shell {
  background: linear-gradient(145deg, rgba(255, 247, 238, .55), rgba(255, 226, 205, .32));
  border-color: rgba(255,255,255,.62);
}

.login-period-morning .login-template-shell,
.login-period-day .login-template-shell {
  background: linear-gradient(145deg, rgba(255,255,255,.58), rgba(240,248,252,.36));
}

.login-template-page::before {
  background: rgba(255,255,255,.06);
  height: 430px;
  inset-inline-start: -140px;
  top: -170px;
  width: 430px;
}

.login-template-page::after {
  background: rgba(255,159,67,.08);
  bottom: -210px;
  height: 520px;
  inset-inline-end: -170px;
  width: 520px;
}

.login-template-content {
  align-items: center;
  display: flex;
  min-height: calc(100vh - 56px);
  position: relative;
  justify-content: center !important;
  padding: 0 !important;
  width: 100% !important;
  z-index: 1;
}

.login-template-shell {
  -webkit-backdrop-filter: blur(30px) saturate(155%);
  backdrop-filter: blur(30px) saturate(155%);
  background: linear-gradient(145deg, rgba(255,255,255,.42), rgba(255,255,255,.22));
  border: 1px solid rgba(255,255,255,.66);
  border-radius: 24px;
  box-shadow: 0 32px 90px rgba(4, 25, 44, .3), inset 0 1px 0 rgba(255,255,255,.72);
  display: block;
  margin: 0 auto;
  max-width: 460px;
  min-height: auto;
  overflow: hidden;
  width: 100%;
}

.login-visual {
  align-items: center;
  background: linear-gradient(145deg, #0d3154 0%, #174f7b 58%, #2479a8 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 58px 58px 30px;
  position: relative;
}

.login-visual-copy {
  color: #fff;
  max-width: 470px;
  position: relative;
  width: 100%;
  z-index: 2;
}

.login-visual-badge {
  align-items: center;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.18);
  border-radius: 999px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 7px;
  letter-spacing: .04em;
  padding: 8px 12px;
  text-transform: uppercase;
}

.login-visual-badge :deep(svg) {
  height: 15px;
  width: 15px;
}

.login-visual h1 {
  color: #fff;
  font-size: clamp(32px, 4vw, 48px);
  font-weight: 750;
  letter-spacing: -.035em;
  margin: 24px 0 14px;
}

.login-visual p {
  color: rgba(255,255,255,.76);
  font-size: 16px;
  line-height: 1.75;
  margin: 0;
  max-width: 440px;
}

.login-visual-orb {
  border-radius: 50%;
  position: absolute;
}

.login-visual-orb-one {
  background: rgba(255,159,67,.2);
  height: 280px;
  inset-inline-end: -100px;
  top: -90px;
  width: 280px;
}

.login-visual-orb-two {
  background: rgba(255,255,255,.07);
  bottom: -150px;
  height: 420px;
  inset-inline-start: -150px;
  width: 420px;
}

.login-form-panel {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 44px 46px 46px;
}

.login-form-panel .login-content,
.login-form-panel form,
.login-form-panel .login-userset {
  max-width: 390px;
  width: 100%;
}

.login-form-panel .login-logo {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.login-form-panel .login-logo img {
  max-height: 62px;
  max-width: 210px;
  object-fit: contain;
}

.login-secure-badge {
  align-items: center;
  background: rgba(14, 74, 116, .08);
  border: 1px solid rgba(14, 74, 116, .12);
  border-radius: 999px;
  color: #315b7b;
  display: flex;
  font-size: 11px;
  font-weight: 700;
  gap: 6px;
  justify-content: center;
  margin: 15px auto 0;
  padding: 6px 10px;
  text-transform: uppercase;
  width: max-content;
}

.login-secure-badge :deep(svg) {
  height: 13px;
  width: 13px;
}

.login-form-panel .logo-white {
  display: none;
}

.login-form-panel .brand-tagline {
  margin: 12px 0 27px;
}

.login-form-panel .login-userheading {
  margin: 30px 0 28px;
  text-align: center;
}

.login-form-panel .login-userheading h3 {
  color: #112f4e;
  font-size: 29px;
  font-weight: 750;
  letter-spacing: -.02em;
  margin-bottom: 9px;
}

.login-form-panel .login-userheading h4 {
  color: #617487;
  font-size: 14px;
  line-height: 1.65;
  margin: 0;
}

.login-form-panel .form-addons,
.login-form-panel .pass-group {
  position: relative;
}

.login-form-panel .form-control {
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,.38);
  border: 1px solid rgba(255,255,255,.58);
  border-radius: 11px;
  box-shadow: none;
  height: 50px;
  margin-top: 0 !important;
  padding-inline: 15px 48px;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.login-form-panel .form-control:focus {
  background: rgba(255,255,255,.64);
  border-color: #ff9f43;
  box-shadow: 0 0 0 4px rgba(255,159,67,.12);
}

.login-form-panel .field-icon,
.login-form-panel .toggle-password {
  align-items: center;
  color: #8191a5;
  display: flex;
  height: 34px;
  inset-inline-end: 10px;
  justify-content: center;
  position: absolute;
  top: 25px;
  transform: translateY(-50%);
  width: 34px;
}

.login-form-panel .field-icon {
  pointer-events: none;
}

.login-form-panel .toggle-password {
  cursor: pointer;
}

.login-form-panel .btn-login {
  align-items: center;
  border-radius: 11px;
  display: flex;
  gap: 10px;
  height: 50px;
  justify-content: center;
  margin-top: 12px;
  width: 100%;
  background: #ff9f43 !important;
  border-color: #ff9f43 !important;
  box-shadow: 0 12px 24px rgba(255,159,67,.28);
  color: #fff !important;
  font-weight: 700;
}

.login-forgot-row {
  margin: -2px 0 15px;
  text-align: end;
}

.login-forgot-row a {
  color: #294f70;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
}

.login-forgot-row a:hover {
  color: #f38b27;
}

.login-form-panel .btn-login:hover,
.login-form-panel .btn-login:focus {
  background: #f38b27 !important;
  border-color: #f38b27 !important;
  box-shadow: 0 14px 28px rgba(255,159,67,.36) !important;
  color: #fff !important;
  transform: translateY(-1px);
}

.login-submit-arrow {
  height: 17px;
  width: 17px;
}

.login-template-page:dir(rtl) .login-submit-arrow {
  transform: rotate(180deg);
}

@media (max-width: 991px) {
  .login-template-page {
    padding: 20px;
  }

  .login-template-content {
    min-height: calc(100vh - 40px);
  }

  .login-template-shell {
    max-width: 460px;
    min-height: auto;
  }

  .login-visual {
    display: none;
  }

  .login-form-panel {
    min-height: 0;
    padding: 44px 46px 46px;
  }
}

@media (max-width: 575px) {
  .login-template-page {
    padding: 0;
  }

  .login-template-content {
    min-height: 100vh;
  }

  .login-template-shell {
    border-radius: 22px;
    margin: 16px;
    min-height: 0;
    width: calc(100% - 32px);
  }

  .login-form-panel {
    min-height: 0;
    padding: 48px 24px 38px;
  }
}
</style>

<style>
/* Login field direction must override the legacy theme's fixed right values. */
html:not([dir="rtl"]) .login-modern .form-addons .field-icon,
html:not([dir="rtl"]) .login-modern .pass-group .toggle-password {
  left: auto !important;
  right: 10px !important;
}

html:not([dir="rtl"]) .login-modern .form-login input {
  direction: ltr;
  padding-left: 14px !important;
  padding-right: 50px !important;
  text-align: left;
}

html[dir="rtl"] .login-modern .form-addons .field-icon,
html[dir="rtl"] .login-modern .pass-group .toggle-password {
  left: 10px !important;
  right: auto !important;
}

html[dir="rtl"] .login-modern .form-login input {
  padding-left: 50px !important;
  padding-right: 14px !important;
  text-align: right;
}

html[dir="rtl"] .login-modern input[name="email"] {
  direction: ltr;
}

html[dir="rtl"] .login-modern input[name="password"] {
  direction: rtl;
}
</style>
